import useUtil from './useUtil'
import { COUNTRY_OPTIONS, GENDER_OPTIONS } from 'constants/options'

const useOptionConstant = () => {
  const { getOptions } = useUtil()

  return {
    genderOptions: getOptions(GENDER_OPTIONS),
    countryOptions: getOptions(COUNTRY_OPTIONS)
  }
}

export default useOptionConstant
